// extracted by mini-css-extract-plugin
export var billingAddress = "_qm-g";
export var contactInfo = "_qm-d";
export var customerInfoContainer = "_qm-c";
export var customerInfoContainerMobile = "_qm-h";
export var customerInfoRow = "_qm-a";
export var customerInfoSection = "_qm-b";
export var fullWidthDividerMobile = "_qm-i";
export var imageContainer = "_qm-1";
export var paymentMethod = "_qm-e";
export var priceText = "_qm-6";
export var priceTextMobile = "_qm-7";
export var product = "_qm-0";
export var productImage = "_qm-2";
export var productInfo = "_qm-4";
export var productMobile = "_qm-9";
export var productTitle = "_qm-8";
export var quantityBadge = "_qm-3";
export var quantityText = "_qm-5";
export var shippingAddress = "_qm-f";